function initVimeoPlayers() {
  const containers = document.querySelectorAll(".vimeo");
  if (!containers.length) return;

  containers.forEach((container) => {
    const video = container.querySelector(".video");
    const playPauseBtn = container.querySelector(".playPauseBtn");
    const muteBtn = container.querySelector(".muteBtn");
    const progressBar = container.querySelector(".progress-bar");
    const timeDisplay = container.querySelector(".time-display");
    const fullscreenBtn = container.querySelector(".fullscreenBtn");

    if (!video) return;

    // PLAY / PAUSE
    if (playPauseBtn) {
      playPauseBtn.addEventListener("click", () => {
        if (video.paused) {
          video.play();
          playPauseBtn.textContent = "Pause";
        } else {
          video.pause();
          playPauseBtn.textContent = "Play";
        }
      });
    }

    // MUTE / UNMUTE
    if (muteBtn) {
      muteBtn.addEventListener("click", () => {
        if (video.muted) {
          document.querySelectorAll(".video").forEach((v) => {
            v.muted = true;
            const btn = v.closest(".vimeo")?.querySelector(".muteBtn");
            if (btn) btn.textContent = "Unmute";
          });
          video.muted = false;
          muteBtn.textContent = "Mute";
        } else {
          video.muted = true;
          muteBtn.textContent = "Unmute";
        }
      });
    }

    // FULLSCREEN
    if (fullscreenBtn) {
      fullscreenBtn.addEventListener("click", () => {
        const isFullscreen = !!document.fullscreenElement;
        if (!isFullscreen) {
          if (video.requestFullscreen) video.requestFullscreen();
          else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
          else container.requestFullscreen();
          fullscreenBtn.textContent = "Fullscreen";
        } else {
          document.exitFullscreen();
          fullscreenBtn.textContent = "Fullscreen";
        }
      });

      document.addEventListener("fullscreenchange", () => {
        fullscreenBtn.textContent = document.fullscreenElement ? "Fullscreen" : "Fullscreen";
      });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const container = entry.target;
          const video = container.querySelector(".video");
          const muteBtn = container.querySelector(".muteBtn");

          if (!video) return;

          if (!entry.isIntersecting) {
            // Fuera de pantalla → mute (y opcional pause)
            video.muted = true;
            // video.pause(); // 👈 opcional si quieres parar también

            if (muteBtn) muteBtn.textContent = "Unmute";
          }
        });
      },
      {
        threshold: 0.3, // visible al menos un 30%
      },
    );

    // observar todos los containers
    containers.forEach((container) => observer.observe(container));

    // PROGRESO
    function updateProgress() {
      const current = video.currentTime;
      const duration = video.duration;
      if (!isNaN(duration) && progressBar) {
        progressBar.max = duration;
        progressBar.value = current;
      }
      if (timeDisplay) timeDisplay.textContent = formatTime(current);
      requestAnimationFrame(updateProgress);
    }
    video.addEventListener("play", () => requestAnimationFrame(updateProgress));

    if (progressBar) {
      progressBar.addEventListener("input", () => {
        video.currentTime = progressBar.value;
      });
    }

    function formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    }
  });
}

document.addEventListener("DOMContentLoaded", initVimeoPlayers);
